import React from "react";
import { framework_tool, component_tool } from "@/tool";
import { WizBraftEditorPlus } from "@/containers/common";
import { CustomTabs, GridLayouts } from "@/components";
import { withRouter } from "dva/router";
import "./style/index.less";
const {
  WizComponent,
  WizSelect,
  WizCheckbox,
  WizButton,
  WizIcon,
  WizRow,
  WizCol,
  WizInput,
  WizModal,
  WizTooltip,
  WizEmpty,
  Wizmessage
} = component_tool;
const { WizOssUpload, ossFileUtils } = framework_tool;
const { TextArea } = WizInput;

const {getOssImgResizeUrl, getOssUrlBySuffix} = ossFileUtils

class ContentText extends WizComponent {
  // 组件名 必传
  componentName = "ContentText";

  // 构造函数
  constructor(props) {
    super(props);
    this.isupdate = !!props.history.location.pathname.includes("DetailUpd");
    this.state = {
      contentType: !this.isupdate ? 1 : props.contentType,
    };
  }

  CreateDiyContent = () => {
    const { contentType } = this.state
    const props = { ...this.props, value: this.props.value instanceof Array ? this.props.value : this.props.value && this.props.value.contentText, contentType }
    let content;
    switch (contentType) {
      case 1:
        content = <Editor {...props} />;
        break;
      case 2:
        content = <Images {...props} />;
        break;
      case 3:
        content = <Video {...props} />;
        break;
      case 4:
        content = <Document {...props} />;
        break;
      case 5:
        content = <DownLoad {...props} />;
        break;
      default:
        content = <WizEmpty />;
        break;
    }
    return content;
  };

  // 内容类型状态变化
  handleSelectOnChange = (value) => {
    const { onChange } = this.props;
    this.setState({ contentType: value });
    onChange && onChange({ contentType: value, contentText: [] });
  };

  render() {
    const { hiddenType } = this.props
    const { contentType } = this.state;

    const fields = [
      { label: "文章", value: 1 },
      { label: "图片", value: 2 },
      { label: "视频", value: 3 },
      hiddenType === 'learningMaterials' ? { label: "文档文件", value: 4 } : null,
      hiddenType === 'content' ? { label: "下载文件", value: 5 } : null,
    ].filter(item => !!item);
    return (
      <React.Fragment>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div>请选择内容类型:</div>
          <WizSelect
            defaultValue={contentType}
            onChange={this.handleSelectOnChange}
            style={{ width: 300, marginLeft: 10 }}
          >
            {fields.map((val) => (
              <WizSelect.Option key={val.value} value={val.value}>
                {val.label}
              </WizSelect.Option>
            ))}
          </WizSelect>
        </div>
        {this.CreateDiyContent()}
      </React.Fragment>
    );
  }
}

export default withRouter(ContentText);
// 文章
class Editor extends WizComponent {
  // 组件名 必传
  componentName = "Editor";

  handleChange = (value, watermark) => {
    const { onChange } = this.props
    onChange && onChange({
      watermark: watermark, //是否添加水印
      contentType: 1,
      contentText: [{ contentDetail: value }],
    })
  }

  render() {
    const { watermark, value, hiddenType } = this.props
    const _value = value.length ? value[0].contentDetail : null
    return [
      <WizBraftEditorPlus links={[0, 1, 2, 3]} value={_value} onChange={e => this.handleChange(e, watermark)} />,
      hiddenType === 'learningMaterials' ? <React.Fragment>
        添加水印：
        <WizCheckbox
          defaultChecked={watermark}
          onChange={e => this.handleChange(_value, e?.target?.checked ? 1 : 0)}
        />
      </React.Fragment> : null
    ]
  }
}

// 图片
class Images extends WizComponent {
  // 组件名 必传
  componentName = "Images";

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      watermark: props.watermark, //是否添加水印
      initialLayout: [],
      images: props.value || [],
      imagesKey: null,
      removeImageKeys: [],
      visible: false,
      currentImageIndex: 0,
    };
    this.images = props.value || []
  }

  componentWillMount() {
    const { images } = this.state;
    if (!images.length) return;
    const _initialLayout = this.createInitialLayout(images);
    console.log('_initialLayout', _initialLayout)
    this.setState({
      initialLayout: _initialLayout,
      imagesKey: new Date().getTime(),
    });
  }

  createInitialLayout = (values) => {
    const { isupdate } = this.props
    return values.map((val, index) => {
      return {
        x: index,
        y: Math.floor(index / 4),
        w: 3,
        h: 1,
        // static: isupdate ? true : false,
        i: index.toString(),
      };
    });
  };

  // 图片上传状态变化
  handleUploadImageOnChange = (values) => {
    const {watermark, removeImageKeys, images} = this.state

    let _images = values.filter(({status}) => ['error', 'removed'].indexOf(status) === -1).map(value => {
      let {uid, status, fileId, sysUrl, url} = value

      return {
        uid,
        fileId,
        status,
        fileUri: sysUrl || url
      }
    });

    _images = [...this.images, ..._images]
      .filter(({fileId}) => removeImageKeys.indexOf(fileId) === -1)
      .map((image, index) => ({...image, contentDetail: images[index]?.contentDetail, order: index}))

    this.imagesOnChange(watermark, _images)
  };

  // 图片描述内容变化
  handleTextAreaOnchange = (e, index) => {
    const { watermark, images } = this.state;
    const _images = JSON.parse(JSON.stringify(images));
    const currentItem = { ...images[index], contentDetail: e.target.value };
    _images.splice(index, 1, currentItem);
    this.imagesOnChange(watermark, _images);
  };

  // 删除图片
  handleDelete = (index) => {
    const { watermark, images, removeImageKeys } = this.state;
    const _images = JSON.parse(JSON.stringify(images));
    const {uid, fileId, status} = _images.splice(index, 1)[0];
    // 上传的文件还在上传中时不允许删除
    if(!!uid && status !== 'done') {
      Wizmessage.warn('该图片正在上传中请稍后在试')
      return;
    }

    this.setState({
      removeImageKeys: [...removeImageKeys, fileId],
    });
    this.imagesOnChange(watermark, _images);
  };

  // 预览图片
  handlePreview = (index) => {
    this.setState({ visible: true, currentImageIndex: index });
  };

  // 上传图片状态变化时 改变表单状态
  imagesOnChange = (watermark, images = []) => {
    const {removeImageKeys} = this.state
    const { hiddenType, onChange } = this.props;

    if(hiddenType === 'learningMaterials' && images.length > 20) {
      Wizmessage.destroy()
      Wizmessage.warn('图片数量不得超过20张')

      let oldIds = this.state.images.map(({fileId, uid}) => fileId || uid);
      // 清理缓存内未上传的图片
      this.setState({
        removeImageKeys: [...removeImageKeys, ...images.filter(({fileId, uid}) => {
         if (fileId && oldIds.indexOf(fileId) !== -1) {
           return false
         } else if (uid && oldIds.indexOf(uid) !== -1) {
           return false
         }
         return true;
        }).map(({fileId, uid}) => fileId || uid)],
      })
      return;
    }

    const _initialLayout = this.createInitialLayout(images);
    this.setState({
      imagesKey: images?.length || 0,
      initialLayout: _initialLayout,
      watermark: watermark,
      images: images,
    })
    onChange && onChange({
      contentType: 2,
      watermark: watermark,
      contentText: images,
    });
  };

  onLayoutChange = (layout, layouts) => {
    //⭐️需要补充顺序改变后修改 state中images顺序的逻辑
    // if(!this.state.imagesKey) return
    // this.setState({
    //   imagesKey: new Date().getTime()
    // });
  };

  render() {
    const {
      watermark,
      images,
      imagesKey,
      initialLayout,
      visible,
      currentImageIndex,
    } = this.state;
    const layoutPorps = {
      initialLayout,
      // storeKey: "l",
      className: "gridlayout",
      rowHeight: images.length ? 160 : 0,
      draggableCancel: ".image-item-desc .image-item-img",
      draggableHandle: ".image-item-imgbox-mask",
      compactType: "horizontal",
      measureBeforeMount: false,
      // preventCollision: true,
      // useCSSTransforms: false,
      onLayoutChange: this.onLayoutChange,
      key: imagesKey,
    };
    const modalProps = {
      visible,
      // width: 800,
      footer: null,
      onCancel: () => {
        this.setState({ visible: false });
      },
    };
    const props = {
      label: "图片上传",
      uploadComp: () => (
        <WizOssUpload
          style={{ margin: "0 10px" }}
          onChange={this.handleUploadImageOnChange}
          onReve
          multiple
          aspectRatio={1.85}
          accept={".jpg, .jpeg, .png"}
          uploadType={"temp"} //⭐️表示临时储存空间，正式业务请根据场景自行传入
          showUploadList={false}
        >
          <WizButton>
            <WizIcon type="upload" />
            图片上传
          </WizButton>
        </WizOssUpload>
      ),
      // extra: '（限20张图片；支持文件类型：.jpg;.png;.jpeg）',
      content: () =>
        images.length ? (
          <React.Fragment>
            <GridLayouts {...layoutPorps}>
              {images.map((val, index) => (
                <div key={index.toString()}>
                  <WizRow type="flex" gutter={2} className="image-item">
                    <WizCol span={14} className="image-item-imgbox">
                      <img
                        className="image-item-img"
                        src={getOssImgResizeUrl(val.fileUri, {
                          m: "lfit",
                          w: 300,
                          h: 200,
                        }, true)}
                        alt=""
                      />
                      <div className="image-item-imgbox-mask"></div>
                    </WizCol>
                    <WizCol span={10} className="image-item-desc">
                      <TextArea
                        placeholder="请输入描述..."
                        defaultValue={val.contentDetail}
                        onChange={(e) => this.handleTextAreaOnchange(e, index)}
                      ></TextArea>
                    </WizCol>
                    {/* <WizIcon
                      type="unordered-list"
                      className="image-item-icon"
                    /> */}
                    <div className="image-item-mask">
                      <WizTooltip title="预览">
                        <WizIcon
                          type="eye"
                          className="icon"
                          onClick={() => {
                            this.handlePreview(index);
                          }}
                        />
                      </WizTooltip>
                      <WizTooltip title="删除">
                        <WizIcon
                          type="delete"
                          className="icon"
                          onClick={() => {
                            this.handleDelete(index);
                          }}
                        />
                      </WizTooltip>
                    </div>
                  </WizRow>
                </div>
              ))}
            </GridLayouts>
            {visible ? (
              <WizModal {...modalProps}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={getOssImgResizeUrl(
                      images[currentImageIndex].fileUri,
                      { m: "lfit", w: 800, h: 420 },
                      undefined
                    )}
                    style={{ maxWidth: "100%" }}
                  />
                </div>
              </WizModal>
            ) : null}
          </React.Fragment>
        ) : null,
      footer: () => (
        <React.Fragment>
          添加水印：
          <WizCheckbox
            defaultChecked={watermark}
            onChange={e => this.imagesOnChange(e.target.checked ? 1 : 0, images)}
          />
        </React.Fragment>
      ),
    };

    return <ContentComp {...props} />;
  }
}

// 视频
class Video extends WizComponent {
  // 组件名 必传
  componentName = "Video";

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      fileList: [], //视频对象
      watermark: props.watermark, //是否添加水印
    };
  }

  componentWillMount() {
    const { value } = this.props;
    if (value && value.length) {
      this.setState({
        fileList: [
          {
            uid: value[0].fileId,
            name: value[0].fileName,
            url: getOssFilePath(value[0].fileId),
            status: "done",
            ...value[0],
          },
        ],
      });
    }
  }

  // 添加水印复选框状态发生变化
  handleCheckboxOnChange = (e) => {
    this.setState({ watermark: e.target.checked ? 1 : 0 }, () => {
      this.videoOnChange(this.state.fileList);
    });
  };

  // 视频上传变化
  handleUploadVideoOnChange = values => {
    if (!values.length) {
      this.videoOnChange([])
      return
    }
    const _value = values[values.length - 1];
    if (_value && _value.status !== "done") return;
    this.setState({ fileList: [_value] }, () => {
      this.videoOnChange([_value]);
    });
  };

  // 上传视频状态变化时 改变表单状态
  videoOnChange = (values) => {
    const { onChange } = this.props;
    onChange &&
      onChange({
        contentType: 3,
        watermark: this.state.watermark,
        contentText: values,
      });
  };

  render() {
    const { watermark, fileList } = this.state;
    const props = {
      label: "视频上传",
      uploadComp: () => (
        <WizOssUpload
          style={{ margin: "0 10px" }}
          onChange={this.handleUploadVideoOnChange}
          multiple={false}
          value={fileList}
          accept={".mp4, .AVI, .mov, .rmvb, .rm, .FLV, .3GP, .MPEG, .WMV"}
          uploadType={"temp"} //⭐️表示临时储存空间，正式业务请根据场景自行传入
          beforeUpload={file => {
            const isLt1M = file.size / 1024 / 1024 /1024 < 4;
            if (!isLt1M) {
              Wizmessage.error('视频大小不得超过4G!');
              return false;
            }
            return isLt1M;
          }}
        >
          <WizButton>
            <WizIcon type="upload" />
            视频上传
          </WizButton>
        </WizOssUpload>
      ),
      footer: () => (
        <React.Fragment>
          添加水印：
          <WizCheckbox
            defaultChecked={watermark}
            onChange={this.handleCheckboxOnChange}
          />
        </React.Fragment>
      ),
    };
    return <ContentComp {...props} />;
  }
}

// 文档
class Document extends WizComponent {
  // 组件名 必传
  componentName = "Document";

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      fileList: [], //文件列表
      watermark: props.watermark,// 是否添加水印
    };
  }

  componentWillMount() {
    const { value, hiddenType } = this.props
    if (!value.length) return
    const fileList = value.map(val => {
      return {
        uid: val.fileId,
        name: val.fileName,
        url: getOssFilePath(val.fileId),
        status: "done",
      };
    });
    this.setState({ fileList });
  }

  handleCheckboxOnChange = (e) => {
    this.setState({ watermark: e.target.checked ? 1 : 0 }, () => {
      this.handleUploadFileOnChange(this.state.fileList);
    });
  };

  // 文件上传变化
  handleUploadFileOnChange = (values) => {
    this.setState({ fileList: values }, () => {
      this.fileOnChange(values);
    });
  };

  fileOnChange = (values = []) => {
    const { onChange } = this.props;
    onChange &&
    onChange({
      contentType: 4,
      watermark: this.state.watermark,
      contentText: values.length
        ? values.map((val) => {
          return { fileId: val.fileId || val.uid };
        })
        : [],
    });
  };

  render() {
    const { fileList, watermark } = this.state;
    const props = {
      label: "文档文件",
      uploadComp: () => (
        <WizOssUpload
          style={{ margin: "0 10px" }}
          onChange={this.handleUploadFileOnChange}
          value={fileList}
          multiple
          accept={".doc, .docx, .ppt, .pptx, .pdf"}
          uploadType={"system"}
        >
          <WizButton>
            <WizIcon type="upload" />
            文档上传
          </WizButton>
        </WizOssUpload>
      ),
      footer: () => (
        <React.Fragment>
          添加水印：
          <WizCheckbox
            defaultChecked={watermark}
            onChange={this.handleCheckboxOnChange}
          />
        </React.Fragment>
      ),
    };

    return <ContentComp {...props} />;
  }
}

// 下载
class DownLoad extends WizComponent {
  // 组件名 必传
  componentName = "DownLoad";

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      fileList: [], //文件列表
    };
  }

  componentWillMount() {
    const { value } = this.props
    if (!value.length) return
    const fileList = value.map(val => {
      return {
        uid: val.fileId,
        name: val.fileName,
        url: getOssUrlBySuffix(val.fileUri),
        status: "done",
      };
    });
    this.setState({ fileList });
  }

  // 文件上传变化
  handleUploadFileOnChange = (values) => {
    this.setState({ fileList: values }, () => {
      this.fileOnChange(values);
    });
  };

  fileOnChange = (values = []) => {
    const { onChange } = this.props;
    onChange &&
      onChange({
        contentType: 5,
        contentText: values.length
          ? values.map((val) => {
            return { fileId: val.fileId || val.uid };
          })
          : [],
      });
  };

  render() {
    const { fileList } = this.state;
    const props = {
      label: "下载文件",
      uploadComp: () => (
        <WizOssUpload
          style={{ margin: "0 10px" }}
          onChange={this.handleUploadFileOnChange}
          value={fileList}
          multiple
          // accept={".jpg, .jpeg, .png"}
          uploadType={"temp"} //⭐️表示临时储存空间，正式业务请根据场景自行传入
        >
          <WizButton>
            <WizIcon type="upload" />
            文件上传
          </WizButton>
        </WizOssUpload>
      ),
    };

    return <ContentComp {...props} />;
  }
}

// 无状态组件 负责渲染不同类型的内容
function ContentComp({ label, uploadComp, extra, content, footer }) {
  return (
    <div className="contentComp">
      <div className="contentComp-header">
        <span>{label}:</span>
        {uploadComp && uploadComp()}
        {extra ? <span>{extra}</span> : null}
      </div>
      <div className="contentComp-body">{content && content()}</div>
      {footer && footer()}
    </div>
  );
}

// 工具函数
function filterArrayByKeys(values, removeImageKeys) {
  let _values = JSON.parse(JSON.stringify(values));
  for (let i = 0; i <= removeImageKeys.length; i++) {
    _values = _values.filter((val) => val.fileId !== removeImageKeys[i]);
  }
  return _values;
}
